export default __webpack_public_path__ + "static/media/info_icon.57f02e2d.svg";